<template>
  <div className="youtube__tag container">
    <ul>
      <li>
        <a href="/">코딩 애플</a>
      </li>
      <li>
        <a href="/">조코딩</a>
      </li>
      <li>
        <a href="/">노마드 코딩</a>
      </li>
      <li>
        <a href="/">코딩알려주는 누나</a>
      </li>
      <li>
        <a href="/">드림코딩</a>
      </li>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.youtube__tag {
  ul {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    margin-bottom: 50px;
    li {
      a {
        border: 1px solid #e8ecf2;
        padding: 10px 20px;
        margin: 0 10px;
        color: #f7100d;
      }
    }
  }
}
</style>
